import patchReducer from './reducer';
import * as patchesActions from './reducer';

export { patchesActions };

export default patchReducer;
